import * as yup from 'yup';

const TEXT_REQUIRED = 'Is required';
export const SendOfConf = {
  schema: yup.object({
    email: yup.string().email().nullable().required(TEXT_REQUIRED),
    note: yup.string().nullable(),
    is_yacht_visible: yup.boolean().nullable(),
  }),
  defaultValues: {
    email: '',
    note: '',
    is_yacht_visible: true,
  },
  fields: [
    {
      id: 'send_of_divider',
      type: 'divider',
      label: 'Send OF',
      xs: 12,
    },

    {
      id: 'name',
      name: 'name',
      type: 'text',
      label: 'Supplier',
      xs: 12,
      disabled: true,
    },
    {
      id: 'email',
      name: 'email',
      type: 'text',
      label: 'Email',
      required: true,
      xs: 12,
    },
    {
      id: 'note',
      name: 'note',
      type: 'text',
      label: 'Note',
      xs: 12,
    },
    {
      id: 'is_yacht_visible',
      name: 'is_yacht_visible',
      type: 'checkbox',
      label: "Display yacht name in email",
      xs: 12,
    },
  ],
};
